import { getActiveReports } from 'utils/helperMethods';

// models
import ChargeBackList from '../models/chargebackList';
import ChargebackDetailFormat from '../models/ChargebackDetailFormat';

// constants
import {
    GENERATE_CHARGEBACK_REPORT_ERROR,
    GENERATE_CHARGEBACK_REPORT_REQUEST,
    GENERATE_CHARGEBACK_REPORT_SUCCESS,
    GET_ACTIVE_CHARGEBACK_REPORT_ERROR,
    GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS,
    DOWNLOAD_CHARGEBACK_REPORT_ERROR,
    DOWNLOAD_CHARGEBACK_REPORT_SUCCESS,
    FETCH_CHARGEBACK_DATA_REQUEST,
    FETCH_CHARGEBACK_DATA_SUCCESS,
    FETCH_CHARGEBACK_DATA_FAILURE,
    FETCH_CHARGEBACK_DETAILS_REQUEST,
    FETCH_CHARGEBACK_DETAILS_FAILURE,
    FETCH_CHARGEBACK_DETAILS_SUCCESS,
    VALIDATE_CHARGEBACK_FAILURE,
    VALIDATE_CHARGEBACK_SUCCESS,
    RESET_FIND_TRANSACTION_FORM,
    RAISE_CHARGEBACK_SUCCESS,
    RAISE_CHARGEBACK_FAILURE,
    RESET_RAISE_CHARGEBACK_FORM,
    CHARGEBACK_MERCHANT_ACTION_REQUEST,
    CHARGEBACK_MERCHANT_ACTION_SUCCESS,
    CHARGEBACK_MERCHANT_ACTION_FAILURE,
    CHARGEBACK_AGENT_ACTION_REQUEST,
    CHARGEBACK_AGENT_ACTION_SUCCESS,
    CHARGEBACK_AGENT_ACTION_FAILURE,
    RAISE_CHARGEBACK_REQUEST,
    REFUND_DISPUTE_REQUEST,
    REFUND_DISPUTE_SUCCESS,
    REFUND_DISPUTE_FAILURE,
    CHECK_DISPUTE_STATUS_SUCCESS,
    CHECK_DISPUTE_STATUS_REQUEST,
    CHECK_DISPUTE_STATUS_FAILURE,

} from './chargeback.constants';

const initialState = {
    tableData: [],
    charegebackDetailsData: {},
    isLoading: false,
    selectedTransactionDetails: {},
    pagination: {
        pageNumber: 1,
        pageSize: 10,
        pageCount: 10,
    },
    generatedFile: {
        isSuccess: false,
        error: {},
    },
    activeReports: {
        reports: {},
        error: {},
    },
    downloadReport: {},
    error: {},
    raisedChargebackData: {
        isChargebackRaisedSuccess: false,
        isLoading: false,
        error: {},
    },
    chargebackMerchantAction: {
        isMerchantActionSuccess: false,
    },
    chargebackAgentAction: {
        isChargebackAgentAction: false,
    },
    isDisputeUpdatedSucessfully: false
};

export const chargebackReducer = (state = initialState, action) => {
    //console.log("action.type",action.type);
    switch (action.type) {
        
        case FETCH_CHARGEBACK_DATA_SUCCESS: {
            const createChargebackData = new ChargeBackList(action.payload);
            return {
                ...state,
                ...createChargebackData,
                isLoading: false,
                error: {},
            };
        }
        case FETCH_CHARGEBACK_DATA_REQUEST:
            return {
                ...state,
                error: {},
                isLoading: true,
            };
        case FETCH_CHARGEBACK_DATA_FAILURE:
            return {
                ...state,
                ...action.payload,
                tableData: [],
                isLoading: false,
            };

        case FETCH_CHARGEBACK_DETAILS_REQUEST:
            return {
                ...state,
                ...initialState,
                isLoading: true,
            };
        case FETCH_CHARGEBACK_DETAILS_SUCCESS: {
            const createChargebackData = new ChargebackDetailFormat(
                action.payload
            );
            const { chargebackDetails } = createChargebackData;
            //console.log("🚀 ~ chargebackReducer ~ chargebackDetails:", chargebackDetails)
            
            return {
                ...state,
                charegebackDetailsData: {
                    transactionData: chargebackDetails.transactionData || {},
                    chargebackData: chargebackDetails.chargebackData || {},
                    disputeDetails: chargebackDetails.disputeDetails || {},
                    chargebackMetaData:
                        chargebackDetails.chargebackMetaData || {},
                },
                isLoading: false,
            };
        }
        case CHECK_DISPUTE_STATUS_REQUEST: {
            return {
                ...state,
                isLoading: true,
            };
        }
        case CHECK_DISPUTE_STATUS_SUCCESS: {
            return {
                ...state,
                charegebackDetailsData: {
                    ...state.charegebackDetailsData,
                    chargebackMetaData: {
                        ...state.charegebackDetailsData.checchargebackMetaData,
                        currentChargebackStatus: action.payload.status,
                    },
                },
                isLoading: false,
            };
        }
        case CHECK_DISPUTE_STATUS_FAILURE: {
            return {
                ...state,
                isLoading: false,
            };
        }
        case FETCH_CHARGEBACK_DETAILS_FAILURE:
            return {
                ...state,
                ...action.payload,
            };

        case VALIDATE_CHARGEBACK_FAILURE:
            return {
                ...state,
                selectedTransactionDetails: { ...action.payload },
            };
        case VALIDATE_CHARGEBACK_SUCCESS:
            return {
                ...state,
                selectedTransactionDetails: {
                    isSuccess: true,
                    ...action.payload,
                },
            };

        case RESET_FIND_TRANSACTION_FORM:
            return {
                ...state,
                selectedTransactionDetails:
                    initialState.selectedTransactionDetails,
            };

        case RAISE_CHARGEBACK_REQUEST:
            return {
                ...state,
                raisedChargebackData: {
                    isChargebackRaisedSuccess: false,
                    error: {},
                    isLoading: true,
                },
            };

        case RAISE_CHARGEBACK_SUCCESS:
            return {
                ...state,
                raisedChargebackData: {
                    isChargebackRaisedSuccess: true,
                    isLoading: false,
                },
            };

        case RAISE_CHARGEBACK_FAILURE:
            return {
                ...state,
                raisedChargebackData: {
                    ...action.payload,
                    isLoading: false,
                },
            };

        case RESET_RAISE_CHARGEBACK_FORM:
            return {
                ...state,
                raisedChargebackData: initialState.raisedChargebackData,
            };

        case CHARGEBACK_MERCHANT_ACTION_REQUEST:
            return {
                ...state,
                chargebackMerchantAction: {
                    isMerchantActionSuccess: false,
                },
            };

        case CHARGEBACK_MERCHANT_ACTION_SUCCESS:
            return {
                ...state,
                chargebackMerchantAction: {
                    isMerchantActionSuccess: true,
                },
            };

        case CHARGEBACK_MERCHANT_ACTION_FAILURE:
            return {
                ...state,
                chargebackMerchantAction: {
                    ...action.payload,
                },
            };

        case CHARGEBACK_AGENT_ACTION_REQUEST:
            return {
                ...state,
                chargebackAgentAction: {
                    isChargebackAgentAction: false,
                    isLoading: true,
                },
            };

        case CHARGEBACK_AGENT_ACTION_SUCCESS:
            return {
                ...state,
                chargebackAgentAction: {
                    isChargebackAgentAction: true,
                    isLoading: false,
                },
            };

        case CHARGEBACK_AGENT_ACTION_FAILURE:
            return {
                ...state,
                chargebackAgentAction: {
                    isChargebackAgentAction: false,
                    isLoading: false,
                    ...action.payload,
                },
            };
        case DOWNLOAD_CHARGEBACK_REPORT_SUCCESS:
            return {
                ...state,
                downloadReport: { fileUrl: { ...action.payload } },
            };
        case DOWNLOAD_CHARGEBACK_REPORT_ERROR:
            return {
                ...state,
                downloadReport: { ...action.payload },
            };
        case GENERATE_CHARGEBACK_REPORT_REQUEST:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GENERATE_CHARGEBACK_REPORT_SUCCESS:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: true },
            };
        case GENERATE_CHARGEBACK_REPORT_ERROR:
            return {
                ...state,
                generatedFile: { ...action.payload, isSuccess: false },
            };
        case GET_ACTIVE_CHARGEBACK_REPORT_SUCCESS:
            return {
                ...state,
                activeReports: { reports: getActiveReports(action.payload) },
            };
        case GET_ACTIVE_CHARGEBACK_REPORT_ERROR:
            return {
                ...state,
                activeReports: { ...action.payload },
            };
        // CASE OF REFUND DISPUTE
        case REFUND_DISPUTE_REQUEST:
            //console.log("inside the case",REFUND_DISPUTE_REQUEST);
            return {
                ...state,
                isLoading: true,
                isDisputeUpdatedSucessfully: false
            };
        case REFUND_DISPUTE_SUCCESS: {
            return {
                ...state,
                charegebackDetailsData: {
                    ...state.charegebackDetailsData,
                    chargebackMetaData: {
                        ...state.charegebackDetailsData.checchargebackMetaData,
                        currentChargebackStatus: action.payload.status,
                    },
                },
                isLoading: false,
                isDisputeUpdatedSucessfully: true
            };
        }
        case REFUND_DISPUTE_FAILURE:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isDisputeUpdatedSucessfully: false
            };
        // end of refund dispute

        default:
            return state;
    }
};
